const sizePrimaryBtn = {
  width: "15rem",
  height: "4rem",
  fontSize: "1.5rem",
  border: "none",
};

const containerLight = (device, noBg) => {
  return {
    backgroundColor: !noBg && "var(--bg)",
    margin: "1vw",
    padding: "min(7vw, 3rem)",
    display: "flex",
    flexDirection: "column",
    height: device === "pc" ? "50rem" : "30rem",
    width: device === "pc" ? "calc(100vw - max(7vw, 3rem))" : "84vw",
    justifyContent: "flex-start",
    gap: "8rem",
    borderRadius: "5px",
    alignItems: "center",
    boxShadow: !noBg && "var(--shadow-l)",
  };
};

const smallContainer = (device, noBg, height = 55) => {
  return {
    backgroundColor: !noBg && "var(--lighterdarkbg)",
    margin: "1vw",
    padding: "min(7vw, 3rem)",
    display: "flex",
    flexDirection: "column",
    minHeight: device === "pc" ? `${height}rem` : `${height - 25}rem`,
    width: device === "pc" ? "calc(90vw - max(7vw, 3rem))" : "84vw",
    justifyContent: "flex-start",
    gap: "2rem",
    borderRadius: "5px",
    alignItems: "center",
    boxShadow: !noBg && "var(--shadow-l)",
  };
};
const title = (device) => {
  return {
    color: "var(--light)",
    fontSize: device === "pc" ? "calc(10px + 5vw)" : "3rem",
    marginBottom: "0",
    marginTop: "0",
    textShadow: "var(--shadow-l)",
  };
};

const label = (device) => {
  return {
    color: "var(--light)",
    fontSize: device === "pc" ? "calc(10px + 2vw)" : "1rem",
    marginBottom: "0",
    marginTop: "0",
    textShadow: "var(--shadow-l)",
  };
};
export { sizePrimaryBtn, containerLight, smallContainer, title, label };
